import { render, staticRenderFns } from "./physical-results.vue?vue&type=template&id=afc23256&scoped=true"
import script from "./physical-results.vue?vue&type=script&lang=ts"
export * from "./physical-results.vue?vue&type=script&lang=ts"
import style0 from "./physical-results.vue?vue&type=style&index=0&id=afc23256&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc23256",
  null
  
)

export default component.exports